import * as Helper from '../../weave/helpers.mjs';

class FurnitureBasketIndex {
    constructor(form, config) {
        this.form = form;
        this.container = document.getElementById("searchItems");
        this.config = config;

        $('#fullLoadOverlay').stop().fadeIn('fast');
        $('#fullLoaderSpacer').stop().fadeIn('fast');

        this.entityActions = this.config.actions;

        for (var entityAction in this.entityActions) {
            this.entityActions[entityAction].setIndex(this);
        }

        this.toggleButtons();

        document.querySelectorAll('.table-actions button').forEach(b => {
            var btnAction = b.getAttribute("data-action");
            b.addEventListener('click', e => {
                this.entityActions[btnAction].rowsAction(e)
            });
        });

        document.getElementById("selectAll").addEventListener('click', this.selectAll.bind(this));

        this.loadList();
    }

    selectAll(e) {
        this.container.querySelectorAll('.checkMarkInput').forEach(c => {
            c.checked = e.target.checked ? true : false;
        });
        this.toggleButtons();
    }

    toggleButtons (e) {
        var selected = this.container.querySelectorAll('.checkMarkInput:checked');

        if (selected.length == 0) {
            // document.querySelector('button[data-action="addToOrder"').classList.add("disabled");
            document.querySelector('button[data-action="removeFromWishlist"').classList.add("disabled");
        } else {
            // document.querySelector('button[data-action="addToOrder"').classList.remove("disabled");
            document.querySelector('button[data-action="removeFromWishlist"').classList.remove("disabled");
        }
    }

    getSelectedRowIds() {
        let checkboxes = this.container.querySelectorAll('.checkMarkInput:checked');
        let rows = [];

        checkboxes.forEach(c => {
            let row = c.closest("div.productContainer");
            rows.push(row.dataset.id);
        });

        return rows;
    }

    loadList() {
        var formData = new FormData(this.form);
        var url = '/furniture/wishlistIndex';

        fetch(url, {
            body: formData,
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then(text => {
            this.container.innerHTML = text;
            this.stopLoading();
            this.init();
        }).catch(r => {
            Helper.notifyError("Sorry, an error occurred while loading search results");
            this.stopLoading();
        });
    }

    init() {
        this.container.querySelectorAll('.checkMarkInput').forEach(c => {
            c.addEventListener('click', this.toggleButtons.bind(this));
        });
    }

    loading(message) {
        if (!message) {
            message = 'Updating...';
        }

        $('#listLoadOverlay').stop().fadeIn('fast');
        $('#listLoadOverlay .loadingText').text(message);
    }

    stopLoading() {
        $('#fullLoadOverlay').stop().fadeOut('fast');
        $('#fullLoaderSpacer').stop().fadeOut('fast');
        $('#listLoadOverlay').stop().fadeOut('fast');
    }
}

export { FurnitureBasketIndex };